import { KpkMedia } from "@keepeek/commons";

import { UseCopyAttachments, useCopyAttachments } from "./copy";
import { UseDownloadAttachments, useDownloadAttachments } from "./download";

export type UseAttachments = {} & UseDownloadAttachments & UseCopyAttachments;

type UseAttachmentsProps = {
  elementId: KpkMedia["id"] | undefined;
};

export const useAttachments = ({ elementId }: UseAttachmentsProps): UseAttachments => {
  const downloadAttachments = useDownloadAttachments({
    elementId,
  });
  const copyAttachments = useCopyAttachments({ elementId });

  // Redefine loading state, even if it's pulling the same deps in both hooks
  // So we're safe if the deps change in later dev
  const loadingAttachments =
    copyAttachments.loadingAttachments || downloadAttachments.loadingAttachments;
  const loading = copyAttachments.loading || downloadAttachments.loading;

  return {
    ...copyAttachments,
    ...downloadAttachments,
    loadingAttachments,
    loading,
  };
};
